module.exports = __webpack_public_path__ + "img/hero.6e44ee6c.jpg";